import React, { Component } from "react";


class ResourceRequestValueThreeCell extends Component {
    render() {
        const item = this.props.dataItem;
        const values = item.Value3 ? item.Value3.split("|") : []; 
        if (values && values.length > 1) {
            if(values[1] && values[1].trim() != '0.00'){
                return <td className= {"summary-grid-text-align"}>{values[0]} <span className="highlight-red">  ({values[1].trim()}) </span></td>;
            }else{
                return <td clasclassName= {"summary-grid-text-align"}>{values[0]}</td>;
            }
        } else {
            return <td className= {"summary-grid-text-align"}>{item.Value3}</td>;
        }
    }
}

export default ResourceRequestValueThreeCell;
